import React from 'react';

export const Clock = () => {
  return (
    <g
      id="Group_951"
      data-name="Group 951"
      transform="matrix(59.960628,0,0,59.960628,-2638.2676,-6475.7478)"
    >
      <g
        id="Ellipse_213"
        data-name="Ellipse 213"
        transform="translate(44,108)"
        fill="#c2ccd8"
        stroke="#c2ccd8"
        strokeWidth="1.5"
      >
        <circle cx="9" cy="9" r="9" stroke="none" id="circle54" />
        <circle cx="9" cy="9" r="8.25" fill="none" id="circle56" />
      </g>
      <path
        id="Path_2608"
        data-name="Path 2608"
        d="m 22081.867,14579.247 2.736,-2.829 v -4.588"
        transform="translate(-22031.604,-14459.281)"
        fill="none"
        stroke="#ffffff"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </g>
  );
};
